// Vendor JS
import Debug from 'debug';

// Custom JS
import Cig from "../util/Cig";
import cigAPI from '../util/cig-api';
import clientIp from '../util/client-ip';

/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
/* eslint-disable func-names */

class Optin {
	constructor() {
		this.init();
	}

	/**
	 * Initialize the Optin class by adding event handlers
	 */
	async init() {
		this.optInMonsterEvents();
	}

	async optInMonsterEvents() {
		document.addEventListener('om.Dtr.init', (event) => {
			try {
				// Wait for OptinMonster window data to be set
				whenAvailable('_cbn', () => this.dtrInitHandler(event));
			} catch (err) {
				Debug(`cig:error:sage:class:Optin`)(`optInMonsterEvents Error: %s %o`, err.message, err);
			}
		});

		// On form submit, send session info to submitform
		document.addEventListener('om.Optin.success', event => {
			try {
				// Wait for OptinMonster window data to be set
				whenAvailable('_cbn', () => this.optInSuccess(event));
			}
			catch (err) {
				Debug(`cig:error:sage:class:Optin`)(`optInMonsterEvents Error: %s %o`, err.message, err);
			}
		});
	}

	dtrInitHandler(event) {
		const opimCampaignData = event.detail.Campaign.data;

		//! What should this value be? Should it be something we can set through the WP Admin?
		const siteName = 'id';

		const { type: medium = 'banner', name: opimCampaignName = '' } = opimCampaignData;

		const { object_id: objectId, object_key: objectKey } = window.omapi_data || {};

		const opimCampaignSlug = opimCampaignName.replace(/[^0-9a-zA-Z]/g, '_').toLowerCase();

		const defaultSrc = `opim-${medium}.${objectKey}-${objectId}.${siteName}.${opimCampaignSlug}`;

		if (window._cbn !== undefined) {
			window._cbn.push([
				() => {
					window.Caliban.on('sessionSet', (cbn) => {
						const sessionData = cbn.getSessionData();

						const opimSmartTags = {
							src: defaultSrc,
							...sessionData,
						};

						for (const key of Object.keys(opimSmartTags)) {
							event.detail.Dtr.setCustomVariable(key, opimSmartTags[key]);
						}
					});
				},
			]);
		}
	}

	async optInSuccess(event) {
		try {
			// Get submitted email
			const { email } = event.detail.Optin.data.fields;

			if (!Cig.isValidEmailAddress(email)) {
				return false;
			}

			const ip = await clientIp();

			const ua = (window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : '';

			const opimCampaignData = event.detail.Campaign.data;

			Debug(`cig:info:sage:class:Optin`)(`optInSuccess Optin Monster Event: %o`, opimCampaignData);

			// Filter out all the arrays and junk inside this object
			const filteredCampaignData = Object.keys(opimCampaignData)
				.filter(key => (['boolean', 'string', 'number'].indexOf(typeof opimCampaignData[key]) > -1))
				.reduce((obj, key) => {
					obj[key] = opimCampaignData[key];
					return obj;
				}, {});


			const emaildata = {
				vendorid: 'optinmonster',
				data: filteredCampaignData
			};

			const siteName = 'id';

			const { type: medium = 'banner', name: opimCampaignName = '' } = opimCampaignData;

			const { object_id: objectId, object_key: objectKey } = window.omapi_data || {};

			const opimCampaignSlug = opimCampaignName.replace(/[^0-9a-zA-Z]/g, '_').toLowerCase();

			// TODO: this is really just checking if this is local or not so checking logging isn't good
			const defaultSrc = `${Debug.enabled(`cig:info:sage:class:Optin`) ? 'test-' : ''}opim-${medium}.${objectKey}-${objectId}.${siteName}.${opimCampaignSlug}`;

			// TODO: Swap this out when OPIM changes how we pass vars. This is using the "success scripts"
			const cigOpimVars = window.cigOpimVars || {};

			const formpage = window.location.href;
			const rep = opimCampaignSlug;

			// Get session data from Caliban
			let sessionData = {};

			if (window._cbn !== undefined && window._cbn.push([
				function () {
					sessionData = this.getSessionData();
				}
			]));

			if (event.detail.response.success) {
				// Make request to the API with the user's email and the products to subscribe to
				const subscribeResponse = await cigAPI(
					'arm-email-subscription',
					'subscribe',
					{
						email,
						src: defaultSrc,
						ip,
						ua,
						formpage,
						rep,
						emaildata,
						...sessionData,
						...cigOpimVars,
					}
				);

				if (subscribeResponse.data) {

					// If on development machine log response
					Debug(`cig:info:sage:class:Optin`)(`optInSuccess subscribeResponse.data: %o`, subscribeResponse.data);
				}

				// Only attempt to send event if Tag Manager is loaded; otherwise perform action without reporting
				if (window.google_tag_manager) {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: 'emailFormSubmitted',
						eventCallback: () => true,
						eventTimeout: 1000
					});
				}
			}
		} catch (err) {
			Debug(`cig:error:sage:class:Optin`)(`optInSuccess Error: %s %o`, err.message, err);
		}

		return null;
	}
}

export default Optin;
